define('editor/edit/map/controls/location-zoom',['durandal/app', 'plugins/http', 'leaflet-geosearch', 'leaflet-geosearch-eme'], function (app, http) {
    var control = function(options) {
        var self = this;
        self.editorMapId = options.editorMapId;
        self.map = options.mapControl;

        self.addToMap = function () {
            self.geoSearchControl = new L.Control.GeoSearch({
                position: 'topleft',
                showMarker: true,
                zoomLevel: 14,
                provider: new L.GeoSearch.Provider.Eme()
            }).addTo(self.map);
        };
    };

    return control;
});

